<template>
    <div v-if="hasErrors && show" class="rounded-md bg-red-50 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">We found <span class="underline">{{errorCount}} error<span v-if="errorCount > 1">s</span></span> with your submission.</h3>
                <div class="mt-2 text-sm text-red-700">
                    <ul v-if="hasErrors" role="list" class="list-disc pl-5 space-y-1">
                        <li v-for="(error, index) in errors">{{ error }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {XCircleIcon} from "@heroicons/vue/outline";
export default {
    components: {
      XCircleIcon
    },
    computed: {
        errors() {
            return this.$page.props.errors
        },

        hasErrors() {
            return Object.keys(this.errors).length > 0
        },
        errorCount() {
            return Object.keys(this.errors).length
        }
    },
    props: {
        show: false
    }
}
</script>
